import { KNOWLEDGE_GRAPH_FILTERS } from '@api';
import { themeExposureFilterKey } from '@terminal/config/constants';
import { useSearchThemes } from '@terminal/react-query-hooks/themes/useSearchThemes';
import { useFlags } from '@terminal/stores/use-flags/useFlags';
import { useFilterOptionSearch } from '@terminal/views/screener/use-filter-option-search/useFilterOptionSearch';
import { useScreenerStore } from '@terminal/views/screener/use-screener-store/useScreenerStore';
import { useMemo } from 'react';

export const useThemeSearch = (useDefaultOptions = true, enabled?: boolean) => {
  const isNewThemeSearchEnabled = useFlags(state =>
    state.getFeatureFlagState('KG-786-Macro_Financial_Theme')
  );
  const isSearchEnabled = enabled ?? true;
  const { filterGroups } = useScreenerStore();
  const knowledgeGraphFiltersConfigOptions = useDefaultOptions
    ? (filterGroups[KNOWLEDGE_GRAPH_FILTERS]?.allFilters.find(
        filter => filter.key === themeExposureFilterKey
      )?.config.options ?? [])
    : [];

  const {
    data: legacySearchData,
    handleTextChange,
    value,
  } = useFilterOptionSearch({
    filter: themeExposureFilterKey,
    defaultOptions: knowledgeGraphFiltersConfigOptions,
    enabled: isSearchEnabled && !isNewThemeSearchEnabled,
  });
  const shouldSearchNewThemes =
    isSearchEnabled &&
    isNewThemeSearchEnabled &&
    (useDefaultOptions || !!value.trim());
  const { data: newSearchData } = useSearchThemes({
    q: value,
    enabled: shouldSearchNewThemes,
  });

  const themeSearchResults = useMemo(() => {
    if (isNewThemeSearchEnabled) {
      return newSearchData.map(theme => ({
        ...theme,
        isTheme: true,
      }));
    }

    return legacySearchData.map(filterOption => ({
      name: filterOption.name,
      id: filterOption.value.id as string,
      isTheme: true,
    }));
  }, [isNewThemeSearchEnabled, legacySearchData, newSearchData]);

  return {
    themeSearchResults,
    handleTextChange,
  };
};
